__turbopack_context__.v({
  "answer": "FG4M3q_answer",
  "groupItem": "FG4M3q_groupItem",
  "groups": "FG4M3q_groups",
  "question": "FG4M3q_question",
});
